import {
    InputControl,
    Loading,
    Picker,
    TextInput,
} from "@venuepos/react-common";
import { GQLayoutEntitySave, useProductGroupsQuery } from "graphql-sdk";
import { isJSON } from "lib";
import { useTranslation } from "locales";
import React, { useCallback, useEffect, useState } from "react";
import { View } from "react-native";

export function CustomItemSubForm({
    values,
    setValue,
}: {
    values: GQLayoutEntitySave;
    setValue: (field, value) => void;
}) {
    const [t] = useTranslation();

    const [productGroup, setProductGroup] = useState<any>();
    const [externalId, setExternalId] = useState<string>(
        isJSON(values.data)
            ? JSON.parse(values.data)?.externalId
            : values.data?.externalId
    );

    const productGroupsQuery = useProductGroupsQuery({
        variables: {
            pagination: {
                pageSize: 999999,
                sort: "name",
                sortDirection: "ASC",
            },
        },
    });
    const productGroups = productGroupsQuery.data?.productGroups.data;

    const handleExternalIdChange = useCallback(
        (newExternalId: string) => {
            setExternalId(newExternalId);
            setValue(
                "data",
                JSON.stringify({
                    __typename: "CustomItem",
                    productGroupId: productGroup?.id,
                    externalId: newExternalId,
                })
            );
        },
        [productGroup?.id, setValue]
    );

    const handleGroupChange = useCallback(
        (selectedProductGroupId: string) => {
            if (!productGroups?.length) {
                return;
            }

            const groupData = productGroups.find(
                groupItr => groupItr.id === selectedProductGroupId
            );

            if (!groupData) {
                return;
            }

            setProductGroup(groupData);

            setValue(
                "data",
                JSON.stringify({
                    __typename: "CustomItem",
                    productGroupId: groupData.id,
                    externalId: externalId,
                })
            );
        },
        [externalId, productGroups, setValue]
    );

    useEffect(() => {
        const data = isJSON(values.data)
            ? JSON.parse(values.data)
            : values.data;

        if (productGroups && productGroups.length > 0) {
            const groupData = productGroups.find(
                groupItr => groupItr.id === data?.productGroupId
            );

            if (groupData) {
                setProductGroup(groupData);
            }
        }

        setExternalId(data.externalId);
    }, [productGroups, values.data]);

    return (
        <>
            <View>
                <InputControl>
                    <TextInput
                        label={t(
                            "backoffice.common.external_id",
                            "External ID"
                        )}
                        placeholder={t(
                            "backoffice.common.enter_external_id",
                            "Enter external identifier"
                        )}
                        value={externalId}
                        onChangeText={handleExternalIdChange}
                        onClear={() => {
                            handleExternalIdChange("");
                        }}
                    />
                </InputControl>

                <InputControl>
                    {!productGroups || !productGroups.length ? (
                        <Loading
                            message={t(
                                "backoffice.layout.checking_product_groups",
                                "Checking for product groups. Are there any?"
                            )}
                        />
                    ) : (
                        <Picker
                            required
                            label={t(
                                "layout.function_button_form.product_group",
                                "Product group"
                            )}
                            selectedValue={productGroup?.id}
                            onValueChange={handleGroupChange}
                        >
                            <Picker.Item
                                label={t(
                                    "layout.function_button_form.choose_product_group",
                                    "Choose a product group"
                                )}
                                key="__select__"
                                value=""
                            />
                            {productGroups.map(item => (
                                <Picker.Item
                                    key={item.id}
                                    value={item.id}
                                    label={item.name}
                                />
                            ))}
                        </Picker>
                    )}
                </InputControl>
            </View>
        </>
    );
}
